
import { config } from "./config"

export const uploadFile = async (formFile: File): Promise<{ url: string }> => {
    const form = new FormData()
    form.set('file', formFile)

    const res = await fetch(`${config.apiBaseUrl}/api/images`, {
        credentials: 'include',
        method: 'PUT',
        body: form,
    })

    if (res.status >= 400) {
        const { error } = (await res.json()) as { error: string }
        throw new Error(error)
    }

    const { file } = (await res.json()) as { file: { url: string } }
    return file
}

export const deleteFile = async (url: string): Promise<void> => {
    try {
        const search = new URLSearchParams({ url })
        await fetch(`${config.apiBaseUrl}/api/images?${search.toString()}`, {
            credentials: 'include',
            method: 'DELETE',
        })
    } catch {
        // Ignore error
    }
}

